import React, {
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useState,
} from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
// custom hook to get the current pathname in React
import { useMedia } from "react-media";
import { LogoDarkIcon, LogoWhiteIcon } from "../../Actions";
import Logo from "../../Logo";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "../../../../contexts/Auth";
import { sidebarSetter } from "../../../../appRedux/ducks/sidebarOpen";
import { themeSetter } from "../../../../appRedux/ducks/themeMode";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import { ListItemText, makeStyles } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import NestedMenuItem from "material-ui-nested-menu-item";
import ListItemIcon from "@mui/material/ListItemIcon";
import SettingsIcon from "@mui/icons-material/Settings";
import clsx from "clsx";
import { nameChange } from "../../../../appRedux/ducks/changeName";
import { addUserSettingsLoad } from "../../../../appRedux/ducks/userSettings";
import $ from "jquery";
import { liveChatSetter } from "../../../../appRedux/ducks/hideLiveChat";
import SidebarSkeleton from "./SideBarSkeleton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TWRIcon from "../../Icon/SidebarIcons/TWR";
import { runJourneySetter } from "../../../../appRedux/ducks/runJourney";
import TradingToolsIcon from "../../Icon/SidebarIcons/TradingToolsIcon";
import ResourcesIcon from "../../Icon/SidebarIcons/ResourcesIcon";
import TAIcon from "../../Icon/SidebarIcons/TAIcon";
import { MaterialUISwitch } from "../../Button/MuiSwitch";

export const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export function useLocalStorage(key, initialState) {
  const [value, setValue] = useState(localStorage.getItem(key) ?? initialState);
  const updatedSetValue = useCallback(
    (newValue) => {
      if (newValue === initialState || typeof newValue === "undefined") {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, newValue);
      }
      setValue(newValue ?? initialState);
    },
    [initialState, key],
  );
  return [value, updatedSetValue];
}

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundColor: theme.palette.primary.tableBackground,
  },
  text: {
    color: theme.palette.primary.text + " !important",
    textDecoration: "none !important",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "18px",
    letterSpacing: "-0.011px",

    "& span": {
      fontSize: "14px!important",
    },
  },
  fill: {
    fill: theme.palette.primary.text + " !important",
  },
}));
const mediaQuery = {
  isMobile: "screen and (max-width: 991px)",
};
export const usePathname = () => {
  const location = useLocation();
  return location.pathname;
};
const SidebarContent = ({
  sidebarOpen,
  themeMode,
  themeToggle,
  nameChanger,
  userSettings,
  setUserSettings,
  setHideChat,
  liveChatExpanded,
  setShowJourney,
  defaultTickersSettings,
}) => {
  const [showChat, setShowChat] = useState(1);
  const { isMobile } = useMedia({
    queries: mediaQuery,
  });
  const {
    minPremium = 3500,
    minContracts = 0,
    expWithinMin = 1,
    expWithinMax = 730,
  } = userSettings;
  const {
    userData,
    tierLevel,
    loading,
    canSeeInternal,
    emeraldPath,
    platinumProgramPath,
    optionsAcademyPath,
  } = useAuth();

  useEffect(() => {
    if (userData) {
      // set default settings for sidebar, send flag to not send network req
      if (!!userData.userSetting && !userData?.notifications) {
        // if user data already exists but notifications have not yet been intialized
        setUserSettings(
          {
            ...userData.userSetting,
            notifications: {
              sound: false,
              mode: 0,
            },
          },
          true,
        );
      } else {
        setUserSettings(userData?.userSettings || userSettings, true);
      }
    }
  }, [userData]);
  const classes = useStyles();
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  // if we are mobile then change sidebarMenu'z zIndex and width to the max
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  const pathName = usePathname();

  useEffect(() => {
    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [window.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  });
  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }
  function tToggle() {
    var body = document.body;
    let classes = Array.from(body.classList);
    if (!classes.includes("sidebar-enable")) {
      body.classList.add("sidebar-enable");
      if (!isMobile) document.body.setAttribute("data-sidebar-size", "sm");
    } else {
      body.classList.remove("sidebar-enable");
      document.body.setAttribute("data-sidebar-size", "lg");
    }
  }
  const color = useMemo(() => {
    return themeMode === "dark" ? "white" : "black";
  }, [themeMode]);
  useEffect(() => {
    const url = "https://salesiq.zoho.com/widget";
    const widgetCode =
      "efa68e65bf844744eb262640a827e2d41325819c78d7bd69df353ef0a840a3a928a7206035e855ece77f3c160cbede31";
    const script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("id", "zoho-script");
    let code = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "${widgetCode}", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="${url}";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);d.innerHTML = "<div id='zsiqwidget'></div>";`;
    script.appendChild(document.createTextNode(code));
    document.body.appendChild(script);
    return () => {
      document.getElementById("zoho-script").remove();
      document.getElementById("zsiqscript").remove();
    };
  }, []);
  useEffect(() => {
    if (showChat > 1) {
      let el = document.getElementById("zsiq_agtpic");
      if (el) el.click();
      setTimeout(() => {
        $("iframe").each(function () {
          $(this)
            .contents()
            .find(".win_close")
            .click(() => {
              //dismissing modal, show chat
              setHideChat(false, liveChatExpanded);
            });
        });
      }, 1000);
    }
  }, [showChat]);

  const ShowChat = () => {
    setShowChat((prev) => prev + 1);
    setHideChat(true, liveChatExpanded);
  };

  const SidebarData = [
    !canSeeInternal && {
      internal: false,
      badge: true,
      title: "Free Account",
      path: "/free-tier",
      pathName: "/free-tier",
      className: pathName.includes("free-tier")
        ? "free-tier-menu single-menu-item"
        : "free-tier-menu single-menu-item",
      icon: <AccountCircleIcon className="free-tier-icon" />,
    },
    {
      internal: true,
      title: "Dashboard",
      className: pathName.includes("home")
        ? "disabled-link single-menu-item "
        : "single-menu-item" + " main-dash-joyride",
      path: "/home/Intraday/Auto/Up",
      pathName: "home",
      icon: (
        <svg
          width="24"
          height="24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 9.39502L12 2.39502L21 9.39502V20.395C21 20.9255 20.7893 21.4342 20.4142 21.8092C20.0391 22.1843 19.5304 22.395 19 22.395H5C4.46957 22.395 3.96086 22.1843 3.58579 21.8092C3.21071 21.4342 3 20.9255 3 20.395V9.39502Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 22.395V12.395H15V22.395"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      className: "brian-joyride ross-joyride",
      internal: true,
      title: "Live Sessions",
      pathName: "market-analysis | live-chat | live-training",
      icon: <TWRIcon width={24} height={24} fill={color} />,
      subNav: [
        {
          pathName: "live-training",
          internal: true,
          title: "Live Training",
          path: `/live-training`,
        },
        {
          pathName: "market-analysis",
          internal: true,
          title: "Trade With Ross",
          path: `/market-analysis`,
        },
        {
          pathName: "live-chat",
          internal: true,
          title: "DayTrade With Brian",
          path: `/live-chat/real-time-trading-alerts`,
        },
      ],
    },
    {
      internal: true,
      title: "Trading Tools",
      pathName:
        "scanner | swing-trades | chart-grid | movement | historical | live-options | option-chain | alerts",
      icon: (
        <TradingToolsIcon
          width={24}
          height={24}
          // fill={color}
          className="trading-tools"
        />
      ),
      className: "sidebar-alerts",
      // customClass: 'custom-font-size',
      subNav: [
        {
          pathName: "scanner",
          internal: true,
          title: "Scanner",
          path: `/scanner`,
        },
        {
          pathName: "swing-trades",
          internal: true,
          title: "Swing Trade AI",
          path: `/swing-trades/0`,
        },
        {
          pathName: "chart-grid",
          internal: true,
          title: "Chart Grid",
          path: `/chart-grid`,
        },
        {
          pathName: "movement",
          internal: true,
          title: "Movement",
          path: `/movement`,
        },
        {
          pathName: "historical",
          internal: true,
          title: "Historical Darkflow",
          path: `/historical/Auto/Up`,
        },
        {
          pathName: "live-options",
          internal: true,
          title: "Live Options",
          path: `/live-options/${minPremium}/${expWithinMin},${expWithinMax}/${minContracts || 0}/${defaultTickersSettings || ""}`,
        },
        {
          pathName: "option-chain",
          internal: true,
          title: "Option Chain",
          path: `/option-chain/${
            userSettings?.defaultOptionChainTicker || "AAPL"
          }`,
        },
        {
          pathName: "alerts",
          internal: true,
          title: "Trade Alerts",
          path: "/alerts/Auto/Up",
        },
      ],
    },
    {
      className: "tutorials-joyride",
      internal: true,
      title: "Resources",
      pathName: "tutorials | live-walkthrough",
      icon: <ResourcesIcon width={24} height={24} className="resources-icon" />,
      // className: 'custom-padding-size',
      // customClass: 'custom-font-size',
      subNav: [
        {
          pathName: "tutorials",
          internal: true,
          title: "Tutorials",
          path: `/tutorials`,
        },
        {
          pathName: "live-walkthrough",
          internal: true,
          title: "Live Walkthrough",
          path: `/live-walkthrough`,
        },
      ],
    },
    {
      divider: true,
    },
    {
      internal: false,
      title: "TradeAlgo Products",
      className: pathName.includes("products")
        ? "disabled-link single-menu-item "
        : "single-menu-item" + " main-dash-joyride",
      path: "/products",
      pathName: "products",
      icon: <TAIcon className="ta-products-icon" width={24} height={24} />,
    },
    {
      internal: false,
      external: true,
      title: "Emerald Inc.",
      path: emeraldPath,
      pathName: "/emerald",
      className: pathName.includes("emerald")
        ? "emerald-link single-menu-item"
        : "emerald-link single-menu-item",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_12448_121364)">
            <path
              d="M14.001 10.0217C14.001 10.6666 13.9984 11.3111 14.0031 11.956C14.0039 12.0783 13.9695 12.1672 13.8863 12.2606C13.2949 12.925 12.7123 13.597 12.1245 14.2647C11.6359 14.8195 11.1422 15.37 10.6539 15.9252C10.0824 16.5748 9.51527 17.2284 8.94452 17.8787C8.56402 18.3124 8.17955 18.7428 7.79833 19.1761C7.48474 19.5324 7.17223 19.8897 6.86082 20.2481C6.78956 20.3299 6.74978 20.3736 6.67201 20.238C6.02893 19.1132 5.37825 17.9926 4.72792 16.8718C4.23711 16.0261 3.74195 15.183 3.25259 14.3367C2.8417 13.6256 2.43734 12.9109 2.02754 12.1991C1.97148 12.1018 2.00367 12.0663 2.09988 12.033C2.71222 11.8207 3.32276 11.6041 3.93365 11.3874C4.69031 11.1191 5.44588 10.8481 6.20326 10.5816C6.7751 10.3801 7.34946 10.1863 7.92094 9.98479C8.37377 9.82529 8.82335 9.6571 9.27619 9.49759C9.8473 9.29613 10.4209 9.1019 10.9921 8.90044C11.4503 8.73877 11.9061 8.56913 12.364 8.40565C12.8613 8.22806 13.3604 8.05409 13.8577 7.8765C14.0071 7.82296 14.001 7.91845 14.001 8.01611C14.0002 8.68487 14.001 9.35364 14.0006 10.0224L14.001 10.0217Z"
              fill="#000"
            />
            <path
              d="M22.0002 12.1208C21.5738 12.8591 21.1708 13.5564 20.7679 14.2537C19.6213 16.2394 18.4737 18.224 17.3318 20.2122C17.2476 20.3594 17.2063 20.3533 17.0971 20.2358C15.5252 18.5391 13.9497 16.8456 12.3702 15.1562C12.2606 15.039 12.2595 14.9742 12.3666 14.8545C13.0248 14.1185 13.6752 13.3756 14.3244 12.6316C14.4018 12.5426 14.4832 12.5032 14.6018 12.4974C16.9181 12.3838 19.234 12.2662 21.5499 12.1491C21.6866 12.1422 21.8233 12.1321 21.9998 12.1212L22.0002 12.1208Z"
              fill="#000"
            />
            <path
              d="M2.14635 11.403C2.03495 11.3849 2.08957 11.3372 2.11597 11.292C2.27837 11.012 2.44004 10.7317 2.60172 10.4514C2.90409 9.92729 3.20466 9.40212 3.50848 8.87875C3.90851 8.18936 4.31288 7.50251 4.71219 6.81277C5.02758 6.26734 5.3361 5.71829 5.65041 5.1725C5.99691 4.57065 6.3492 3.97169 6.69209 3.36766C6.74851 3.26856 6.78613 3.2823 6.8686 3.33185C7.71387 3.83858 8.56167 4.34061 9.40911 4.84336C10.271 5.35515 11.1242 5.88214 11.9985 6.37151C12.4918 6.64748 12.9519 6.97517 13.4449 7.25005C13.4843 7.27212 13.5487 7.28658 13.5487 7.34084C13.5487 7.41065 13.4749 7.38677 13.4351 7.40124C12.5312 7.72459 11.6263 8.04469 10.722 8.36659C9.75597 8.71092 8.79207 9.06068 7.82454 9.40103C6.82881 9.75115 5.8291 10.089 4.83372 10.4394C3.96241 10.7462 3.09471 11.0623 2.2252 11.3744C2.19735 11.3845 2.16914 11.395 2.14635 11.4034V11.403Z"
              fill="#000"
            />
            <path
              d="M17.2464 3.29406C17.535 3.79211 17.8095 4.26448 18.083 4.73721C18.8722 6.10151 19.6614 7.46581 20.4499 8.83047C20.9465 9.68985 21.4394 10.5518 21.9389 11.4093C22.0323 11.5696 21.9227 11.5432 21.8333 11.5479C20.9917 11.592 20.15 11.6372 19.3084 11.6799C17.7994 11.7569 16.29 11.83 14.7814 11.9124C14.6154 11.9215 14.5803 11.8719 14.5811 11.715C14.5869 10.3658 14.5843 9.01638 14.5836 7.66727C14.5836 7.56925 14.5941 7.47991 14.6494 7.39238C15.4867 6.07149 16.3212 4.74878 17.1567 3.42644C17.1791 3.39136 17.2033 3.35736 17.2464 3.2937V3.29406Z"
              fill="#000"
            />
            <path
              d="M16.635 20.6264H7.34204C7.32143 20.5885 7.34205 20.5668 7.3623 20.544C8.81485 18.8939 10.2688 17.2453 11.716 15.5906C11.8314 15.4586 11.8852 15.468 11.997 15.5888C13.5157 17.2287 15.0396 18.8639 16.5619 20.5009C16.5894 20.5306 16.6292 20.5534 16.635 20.6261V20.6264Z"
              fill="#000"
            />
            <path
              d="M7.50476 3.01527C7.59301 3.01129 7.63316 3.00767 7.67331 3.00767C10.6247 3.00767 13.5765 3.00767 16.5279 3.00876C16.5843 3.00876 16.6628 2.97621 16.6924 3.03661C16.721 3.09484 16.6523 3.14222 16.6212 3.19141C15.9188 4.30542 15.2156 5.41907 14.5125 6.53272C14.4803 6.58371 14.446 6.6329 14.4134 6.68354C14.1957 7.02317 14.1971 7.021 13.8448 6.81122C12.3464 5.91784 10.8475 5.02591 9.3483 4.13362C8.77465 3.79218 8.19993 3.45219 7.62629 3.11076C7.59663 3.09303 7.57095 3.06771 7.50439 3.01491L7.50476 3.01527Z"
              fill="#000"
            />
          </g>
          <defs>
            <clipPath id="clip0_12448_121364">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    // {
    //   internal: false,
    //   title: "Subscriptions",
    //   className: "options-mentor-joyride",
    //   pathName: "tradegpt | options-mentorship | options-academy | platinum-program",
    //   icon: (
    //     <TAIcon className='ta-sidebar-icon' width={24} height={24} />
    //   ),
    //   // className: 'custom-padding-size',
    //   // customClass: 'custom-font-size',
    //   subNav: [
    //     {
    //       pathName: "platinum-program",
    //       title: "Platinum Program",
    //       path: platinumProgramPath,
    //     },
    // {
    //   pathName: "options-academy",
    //   title: "Options Academy",
    //   path: optionsAcademyPath,
    // },
    // {
    //   pathName: "options-mentorship",
    //   title: "Options Mentorship",
    //   path: optionsMentorshipPath,
    // },
    //     {
    //       pathName: "tradegpt",
    //       title: "TradeGPT",
    //       path: `/tradegpt`,
    //     },
    //   ],
    // },
    {
      pathName: "platinum-program",
      title: "Platinum Program",
      path: platinumProgramPath,
      className: pathName.includes("platinum-program")
        ? "disabled-link single-menu-item"
        : "single-menu-item",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="plat-icon"
        >
          <g clipPath="url(#clip0_12191_41062)">
            <path
              d="M2 9.57711C3.07837 7.8894 4.16457 6.20548 5.22973 4.51017C5.45578 4.15058 5.73026 3.99905 6.16523 4C10.0707 4.01045 13.9761 4.00903 17.882 4.00143C18.2759 4.00048 18.5362 4.13871 18.7436 4.46694C19.7642 6.08103 20.8015 7.68562 21.8319 9.29401C22.081 9.68257 22.056 9.93765 21.7385 10.2645C18.6844 13.4095 15.6303 16.5546 12.5733 19.6968C12.4769 19.7956 12.3644 19.8967 12.2382 19.948C11.9373 20.0706 11.6848 19.9661 11.468 19.7424C10.6974 18.9453 9.92338 18.1515 9.15081 17.3559C6.89572 15.0345 4.64015 12.7136 2.38898 10.388C2.24121 10.2355 2.12868 10.0502 2 9.88065C2 9.77947 2 9.67829 2 9.57711ZM9.00451 10.3837C10.0022 12.8053 10.9934 15.2103 12.0038 17.6623C13.0234 15.2022 14.0196 12.8001 15.0212 10.3837H9.005H9.00451ZM14.3714 5.29156H9.61513C9.35435 6.56317 9.09503 7.82765 8.83571 9.09213H15.2081C14.9272 7.81625 14.6503 6.55937 14.3714 5.29156ZM3.84311 9.10068H7.50047C7.76077 7.83145 8.0196 6.56744 8.28332 5.28159H8.06559C7.53864 5.28159 7.01168 5.28681 6.48522 5.27826C6.33794 5.27588 6.25428 5.31769 6.17502 5.44261C5.43865 6.60307 4.69446 7.75829 3.9532 8.91542C3.91993 8.96767 3.88959 9.02182 3.84311 9.10115V9.10068ZM15.7062 5.28159C15.9909 6.57457 16.2679 7.83145 16.5467 9.0964H20.1596C20.1111 9.01707 20.0764 8.95817 20.0402 8.90117C19.3948 7.89462 18.7495 6.8876 18.1027 5.88152C17.9759 5.68439 17.8859 5.41554 17.7014 5.31579C17.516 5.21603 17.2337 5.28301 16.9935 5.28206C16.5722 5.28016 16.1509 5.28159 15.7062 5.28159ZM4.16799 10.3747C6.15202 12.4182 8.10228 14.4265 10.0525 16.4344C10.0638 16.3783 10.0511 16.3375 10.0349 16.298C9.24181 14.3724 8.44771 12.4471 7.65753 10.5205C7.61203 10.4098 7.55429 10.3709 7.43002 10.3713C6.40253 10.3766 5.37456 10.3742 4.34707 10.3742C4.3045 10.3742 4.26194 10.3742 4.16799 10.3742V10.3747ZM13.9531 16.3869C13.9624 16.3921 13.9717 16.3973 13.981 16.4026C15.9205 14.4051 17.86 12.4077 19.8244 10.3846C19.7554 10.3794 19.7256 10.3751 19.6957 10.3747C18.6541 10.3747 17.6124 10.377 16.5712 10.3709C16.4406 10.3699 16.4097 10.434 16.3711 10.5271C15.5834 12.4296 14.7932 14.331 14.0045 16.233C13.9839 16.2828 13.9697 16.3356 13.9531 16.3869Z"
              fill="#1C1C1E"
            />
          </g>
          <defs>
            <clipPath id="clip0_12191_41062">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      pathName: "options-academy",
      title: "Options Academy",
      path: optionsAcademyPath,
      className: pathName.includes("options-academy")
        ? "disabled-link single-menu-item"
        : "single-menu-item",
      icon: (
        <svg
          className="plat-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_15439_1996)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.13189 9.40975L12 12.9862L19.8681 9.40975L12 5.83334L4.13189 9.40975ZM1 9.40975C1 9.07391 1.17912 8.73808 1.53735 8.57524L11.2414 4.16433C11.7234 3.94522 12.2767 3.94522 12.7586 4.16433L22.4627 8.57524C23.1791 8.90091 23.1791 9.91856 22.4627 10.2443L19.3333 11.6666V15.5735C19.3333 15.9177 19.2364 16.255 19.0537 16.5468C17.6308 18.8178 15.2389 19.9514 12 19.9514C8.76115 19.9514 6.36922 18.8178 4.94642 16.5469C4.76368 16.2552 4.66675 15.918 4.66667 15.5736V11.6666L2.83333 10.8333V13.5347C2.83333 14.041 2.42292 14.4514 1.91667 14.4514C1.41041 14.4514 1 14.041 1 13.5347V9.40975ZM17.5 12.5L12.7586 14.6552C12.2767 14.8742 11.7234 14.8742 11.2414 14.6552L6.50001 12.5L6.50004 15.5735C7.562 17.2686 9.35457 18.1181 12 18.1181C14.6455 18.1181 16.438 17.2686 17.5 15.5735V12.5Z"
              fill="black"
              fillOpacity="0.87"
            />
          </g>
          <defs>
            <clipPath id="clip0_15439_1996">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      pathName: "options-mentorship",
      title: "Options Mentorship",
      path: "/options-mentorship/plans",
      className: pathName.includes("options-mentorship")
        ? "disabled-link single-menu-item"
        : "single-menu-item",
      icon: (
        <svg
          className="plat-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="icons" clipPath="url(#clip0_15439_2004)">
            <g id="Vector">
              <mask id="path-1-inside-1_15439_2004">
                <path d="M19.5 4H4.83333C3.82225 4 3 4.82225 3 5.83333V15C3 16.0111 3.82225 16.8333 4.83333 16.8333H8.5L6.85 19.0333L8.31667 20.1333L10.7917 16.8333H13.5417L16.0167 20.1333L17.4833 19.0333L15.8333 16.8333H19.5C20.5111 16.8333 21.3333 16.0111 21.3333 15V5.83333C21.3333 4.82225 20.5111 4 19.5 4ZM5.75 12.25H9.41667V14.0833H5.75V12.25Z" />
              </mask>
              <path
                d="M19.5 4H4.83333C3.82225 4 3 4.82225 3 5.83333V15C3 16.0111 3.82225 16.8333 4.83333 16.8333H8.5L6.85 19.0333L8.31667 20.1333L10.7917 16.8333H13.5417L16.0167 20.1333L17.4833 19.0333L15.8333 16.8333H19.5C20.5111 16.8333 21.3333 16.0111 21.3333 15V5.83333C21.3333 4.82225 20.5111 4 19.5 4ZM5.75 12.25H9.41667V14.0833H5.75V12.25Z"
                fill="#1C1C1E"
              />
              <path
                d="M8.5 16.8333L35.1667 36.8333L75.1667 -16.5H8.5V16.8333ZM6.85 19.0333L-19.8167 -0.966671L-39.8167 25.7L-13.15 45.7L6.85 19.0333ZM8.31667 20.1333L-11.6833 46.8L14.9833 66.8L34.9833 40.1333L8.31667 20.1333ZM10.7917 16.8333V-16.5H-5.875L-15.875 -3.16666L10.7917 16.8333ZM13.5417 16.8333L40.2083 -3.16667L30.2083 -16.5H13.5417V16.8333ZM16.0167 20.1333L-10.65 40.1333L9.35002 66.8L36.0167 46.8L16.0167 20.1333ZM17.4833 19.0333L37.4834 45.7L64.15 25.7L44.15 -0.966663L17.4833 19.0333ZM15.8333 16.8333V-16.5H-50.8333L-10.8333 36.8333L15.8333 16.8333ZM5.75 12.25V-21.0833H-27.5833V12.25H5.75ZM9.41667 12.25H42.75V-21.0833H9.41667V12.25ZM9.41667 14.0833V47.4167H42.75V14.0833H9.41667ZM5.75 14.0833H-27.5833V47.4167H5.75V14.0833ZM19.5 -29.3333H4.83333V37.3333H19.5V-29.3333ZM4.83333 -29.3333C-14.5872 -29.3333 -30.3333 -13.5872 -30.3333 5.83333H36.3333C36.3333 23.2317 22.2317 37.3333 4.83333 37.3333V-29.3333ZM-30.3333 5.83333V15H36.3333V5.83333H-30.3333ZM-30.3333 15C-30.3333 34.4206 -14.5872 50.1667 4.83333 50.1667V-16.5C22.2317 -16.5 36.3333 -2.39841 36.3333 15H-30.3333ZM4.83333 50.1667H8.5V-16.5H4.83333V50.1667ZM-18.1667 -3.16667L-19.8167 -0.966671L33.5167 39.0333L35.1667 36.8333L-18.1667 -3.16667ZM-13.15 45.7L-11.6833 46.8L28.3167 -6.53333L26.85 -7.63333L-13.15 45.7ZM34.9833 40.1333L37.4583 36.8333L-15.875 -3.16666L-18.35 0.133336L34.9833 40.1333ZM10.7917 50.1667H13.5417V-16.5H10.7917V50.1667ZM-13.125 36.8333L-10.65 40.1333L42.6833 0.133332L40.2083 -3.16667L-13.125 36.8333ZM36.0167 46.8L37.4834 45.7L-2.51669 -7.63332L-3.98335 -6.53332L36.0167 46.8ZM44.15 -0.966663L42.5 -3.16666L-10.8333 36.8333L-9.18334 39.0333L44.15 -0.966663ZM15.8333 50.1667H19.5V-16.5H15.8333V50.1667ZM19.5 50.1667C38.9206 50.1667 54.6667 34.4206 54.6667 15H-12C-12 -2.39841 2.10159 -16.5 19.5 -16.5V50.1667ZM54.6667 15V5.83333H-12V15H54.6667ZM54.6667 5.83333C54.6667 -13.5872 38.9206 -29.3333 19.5 -29.3333V37.3333C2.10159 37.3333 -12 23.2317 -12 5.83333H54.6667ZM5.75 45.5833H9.41667V-21.0833H5.75V45.5833ZM-23.9167 12.25V14.0833H42.75V12.25H-23.9167ZM9.41667 -19.25H5.75V47.4167H9.41667V-19.25ZM39.0833 14.0833V12.25H-27.5833V14.0833H39.0833Z"
                fill="white"
                mask="url(#path-1-inside-1_15439_2004)"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_15439_2004">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      internal: false,
      external: false,
      title: "TradeGPT",
      path: "/tradegpt",
      className: pathName.includes("tradegpt")
        ? "disabled-link tradegpt-link single-menu-item"
        : "tradegpt-link single-menu-item",
      pathName: "tradegpt",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.20892 3C6.56742 3 5.17986 4.22938 4.98236 5.85938L4.82416 7.16016C4.79816 7.37316 4.86575 7.58657 5.00775 7.74707C5.15025 7.90757 5.35428 8 5.56928 8H20.2363L19.0292 17.9609C18.9217 18.8456 18.1822 19.5 17.291 19.5H6.25092C5.53988 19.5 4.99869 18.9326 4.99994 18.251C5.00147 18.1516 4.98323 18.0529 4.94629 17.9606C4.90935 17.8684 4.85443 17.7844 4.78474 17.7135C4.71505 17.6426 4.63197 17.5863 4.54033 17.5479C4.44869 17.5094 4.35032 17.4895 4.25093 17.4894C4.15154 17.4892 4.05312 17.5089 3.96138 17.5471C3.86964 17.5853 3.78641 17.6414 3.71654 17.7121C3.64666 17.7828 3.59153 17.8667 3.55435 17.9588C3.51716 18.051 3.49867 18.1496 3.49994 18.249C3.49719 19.7444 4.72495 21 6.25092 21H17.291C18.9287 21 20.32 19.767 20.5175 18.1416L21.8271 7.34082V7.33984L21.9804 6.08105C22.0744 5.30005 21.8291 4.51428 21.3076 3.92578C20.7861 3.33728 20.0355 3 19.249 3H8.20892ZM2.74994 9.5C2.65056 9.49859 2.55188 9.51696 2.45966 9.55402C2.36743 9.59108 2.28349 9.6461 2.21271 9.71588C2.14194 9.78566 2.08573 9.86882 2.04737 9.96051C2.00901 10.0522 1.98926 10.1506 1.98926 10.25C1.98926 10.3494 2.00901 10.4478 2.04737 10.5395C2.08573 10.6312 2.14194 10.7143 2.21271 10.7841C2.28349 10.8539 2.36743 10.9089 2.45966 10.946C2.55188 10.983 2.65056 11.0014 2.74994 11H5.99994C6.09932 11.0014 6.198 10.983 6.29022 10.946C6.38245 10.9089 6.46639 10.8539 6.53717 10.7841C6.60794 10.7143 6.66415 10.6312 6.70251 10.5395C6.74087 10.4478 6.76062 10.3494 6.76062 10.25C6.76062 10.1506 6.74087 10.0522 6.70251 9.96051C6.66415 9.86882 6.60794 9.78566 6.53717 9.71588C6.46639 9.6461 6.38245 9.59108 6.29022 9.55402C6.198 9.51696 6.09932 9.49859 5.99994 9.5H2.74994ZM8.67377 9.5C8.4905 9.50013 8.31362 9.56735 8.17652 9.68897C8.03942 9.8106 7.9516 9.97821 7.92963 10.1602L7.5058 13.6602C7.49311 13.7654 7.50288 13.8722 7.53447 13.9734C7.56607 14.0746 7.61876 14.168 7.68908 14.2474C7.7594 14.3267 7.84574 14.3903 7.94242 14.4338C8.03909 14.4774 8.14391 14.4999 8.24994 14.5H17.3251C17.5086 14.5001 17.6857 14.433 17.823 14.3113C17.9603 14.1897 18.0483 14.022 18.0703 13.8398L18.4941 10.3398C18.5068 10.2346 18.497 10.1278 18.4654 10.0266C18.4338 9.92537 18.3811 9.83201 18.3108 9.75264C18.2405 9.67328 18.1541 9.60973 18.0575 9.56618C17.9608 9.52263 17.856 9.50008 17.7499 9.5H8.67377ZM9.33881 11H16.9042L16.6611 13H9.09564L9.33881 11ZM2.74994 12C2.65056 11.9986 2.55188 12.017 2.45966 12.054C2.36743 12.0911 2.28349 12.1461 2.21271 12.2159C2.14194 12.2857 2.08573 12.3688 2.04737 12.4605C2.00901 12.5522 1.98926 12.6506 1.98926 12.75C1.98926 12.8494 2.00901 12.9478 2.04737 13.0395C2.08573 13.1312 2.14194 13.2143 2.21271 13.2841C2.28349 13.3539 2.36743 13.4089 2.45966 13.446C2.55188 13.483 2.65056 13.5014 2.74994 13.5H5.49994C5.59932 13.5014 5.698 13.483 5.79022 13.446C5.88245 13.4089 5.96639 13.3539 6.03717 13.2841C6.10794 13.2143 6.16415 13.1312 6.20251 13.0395C6.24087 12.9478 6.26062 12.8494 6.26062 12.75C6.26062 12.6506 6.24087 12.5522 6.20251 12.4605C6.16415 12.3688 6.10794 12.2857 6.03717 12.2159C5.96639 12.1461 5.88245 12.0911 5.79022 12.054C5.698 12.017 5.59932 11.9986 5.49994 12H2.74994ZM2.74994 14.5C2.65056 14.4986 2.55188 14.517 2.45966 14.554C2.36743 14.5911 2.28349 14.6461 2.21271 14.7159C2.14194 14.7857 2.08573 14.8688 2.04737 14.9605C2.00901 15.0522 1.98926 15.1506 1.98926 15.25C1.98926 15.3494 2.00901 15.4478 2.04737 15.5395C2.08573 15.6312 2.14194 15.7143 2.21271 15.7841C2.28349 15.8539 2.36743 15.9089 2.45966 15.946C2.55188 15.983 2.65056 16.0014 2.74994 16H4.99994C5.09932 16.0014 5.198 15.983 5.29022 15.946C5.38245 15.9089 5.46639 15.8539 5.53717 15.7841C5.60794 15.7143 5.66415 15.6312 5.70251 15.5395C5.74087 15.4478 5.76062 15.3494 5.76062 15.25C5.76062 15.1506 5.74087 15.0522 5.70251 14.9605C5.66415 14.8688 5.60794 14.7857 5.53717 14.7159C5.46639 14.6461 5.38245 14.5911 5.29022 14.554C5.198 14.517 5.09932 14.4986 4.99994 14.5H2.74994Z"
            fill="black"
          />
        </svg>
      ),
    },
    {
      toggleMenuItem: true,
      title: "Dark Mode",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_11544_22137)">
            <path
              d="M19.8999 2.30719C19.739 1.8976 19.1614 1.8976 19.0005 2.30719L18.5701 3.40247C18.521 3.52752 18.4224 3.62651 18.2978 3.67583L17.2065 4.1078C16.7984 4.26934 16.7984 4.849 17.2065 5.01054L18.2978 5.44252C18.4224 5.49184 18.521 5.59082 18.5701 5.71587L19.0005 6.81115C19.1614 7.22074 19.739 7.22074 19.8999 6.81116L20.3303 5.71587C20.3794 5.59082 20.478 5.49184 20.6026 5.44252L21.6939 5.01054C22.102 4.849 22.102 4.26934 21.6939 4.1078L20.6026 3.67583C20.478 3.62651 20.3794 3.52752 20.3303 3.40247L19.8999 2.30719Z"
              fill="black"
            />
            <path
              d="M16.0327 8.1275C15.8717 7.71792 15.2942 7.71792 15.1332 8.1275L14.9763 8.52685C14.9272 8.6519 14.8286 8.75088 14.704 8.8002L14.3061 8.9577C13.898 9.11924 13.898 9.6989 14.3061 9.86044L14.704 10.0179C14.8286 10.0672 14.9272 10.1662 14.9763 10.2913L15.1332 10.6906C15.2942 11.1002 15.8717 11.1002 16.0327 10.6906L16.1896 10.2913C16.2387 10.1662 16.3373 10.0672 16.4619 10.0179L16.8598 9.86044C17.2679 9.6989 17.2679 9.11924 16.8598 8.9577L16.4619 8.8002C16.3373 8.75088 16.2387 8.6519 16.1896 8.52685L16.0327 8.1275Z"
              fill="black"
            />
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 11.5373 21.3065 11.4608 21.0672 11.8568C19.9289 13.7406 17.8615 15 15.5 15C11.9101 15 9 12.0899 9 8.5C9 6.13845 10.2594 4.07105 12.1432 2.93276C12.5392 2.69347 12.4627 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_11544_22137">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      title: "Settings",
      path: "/settings/profile",
      className: pathName.includes("settings")
        ? "disabled-link custom-padding-size bottom-section-settings single-menu-item"
        : "custom-padding-size bottom-section-settings single-menu-item",
      pathName: "settings",
      icon: <SettingsIcon className="settings-menu-item" />,
    },
    {
      className: "support-menu-item",
      internal: false,
      title: "Support",
      icon: (
        <svg
          className="ta-sidebar-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_10906_66866)">
            <path
              d="M22 17.002C21.9996 18.3696 21.5321 19.696 20.675 20.7616C19.8179 21.8273 18.6226 22.5683 17.287 22.862L16.649 20.948C17.2332 20.8518 17.7888 20.6271 18.2758 20.2903C18.7627 19.9534 19.1689 19.5128 19.465 19H17C16.4696 19 15.9609 18.7893 15.5858 18.4142C15.2107 18.0391 15 17.5304 15 17V13C15 12.4696 15.2107 11.9609 15.5858 11.5858C15.9609 11.2107 16.4696 11 17 11H19.938C19.694 9.0669 18.7529 7.28927 17.2914 6.00068C15.8299 4.71208 13.9484 4.00108 12 4.00108C10.0516 4.00108 8.17007 4.71208 6.70857 6.00068C5.24708 7.28927 4.30603 9.0669 4.062 11H7C7.53043 11 8.03914 11.2107 8.41421 11.5858C8.78929 11.9609 9 12.4696 9 13V17C9 17.5304 8.78929 18.0391 8.41421 18.4142C8.03914 18.7893 7.53043 19 7 19H4C3.46957 19 2.96086 18.7893 2.58579 18.4142C2.21071 18.0391 2 17.5304 2 17V12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12V17.002ZM20 17V13H17V17H20ZM4 13V17H7V13H4Z"
              fill="#1C1C1E"
            />
          </g>
          <defs>
            <clipPath id="clip0_10906_66866">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      // className: 'custom-padding-size',
      // customClass: 'custom-font-size',
      subNav: [
        {
          title: "Walkthrough",
          onClick: () => setShowJourney(true),
        },
        {
          title: "Email Support",
          mailTo: "mailto:support@tradealgo.com",
        },
        {
          title: "Live Chat",
          onClick: () => ShowChat(),
        },
      ],
    },
  ].filter(Boolean);

  const parentMenuOpenMobile = useMemo(() => {
    const classes = Array.from(document.body.classList);
    return classes.includes("sidebar-enable");
  }, [Array.from(document.body.classList), sidebarOpen, isMobile]);

  return (
    <React.Fragment>
      <SimpleBar ref={ref}>
        {isMobile && (
          <div style={{ padding: "20px" }}>
            <Logo
              url="/home/Intraday/Auto/Up"
              type="h1"
              icon={
                themeMode === "light" ? (
                  <LogoDarkIcon style={{ width: "30px", height: "20px" }} />
                ) : (
                  <LogoWhiteIcon style={{ width: "30px", height: "20px" }} />
                )
              }
              from={"dashboard"}
              header={true}
              hide={false}
            />
            <IconButton
              onClick={() => tToggle()}
              style={{ float: "right", position: "relative", top: "-5px" }}
              size="medium"
            >
              <ArrowBackIcon style={{ fill: color }} fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <div
          id="sidebar-menu"
          style={{
            zIndex: 10000,
            borderRight: themeMode === "dark" ? "1px solid black" : "",
          }}
        >
          <ul
            style={{ zIndex: 10000, overflow: "unset" }}
            className="metismenu list-unstyled"
            id="side-menu"
          >
            {loading && <SidebarSkeleton />}
            {!loading &&
              SidebarData.map((item, index) => {
                if (tierLevel < item.tier) return null;
                return item.subNav ? (
                  <React.Fragment key={index}>
                    <NestedMenuItem
                      disabled={!!item?.internal && !canSeeInternal}
                      className={`${item?.className || ""} mui-submenu ${pathName.includes(item?.pathName) ? "active" : ""}`}
                      label={
                        sidebarOpen || isMobile ? (
                          <React.Fragment>
                            {item.icon}
                            <ListItemText
                              className={clsx(
                                classes.text,
                                "list-item-text",
                                item?.customClass || "",
                              )}
                            >
                              {item.title}
                            </ListItemText>
                          </React.Fragment>
                        ) : (
                          item.icon
                        )
                      }
                      parentMenuOpen={isMobile ? parentMenuOpenMobile : true}
                    >
                      {item.subNav.map((subItem, subIndex) => {
                        return subItem.mailTo ? (
                          <MenuItem key={subIndex}>
                            <a className="align-mail" href={subItem.mailTo}>
                              <ListItemIcon>{subItem.icon}</ListItemIcon>
                              {subItem.title}
                            </a>
                          </MenuItem>
                        ) : subItem.onClick ? (
                          <MenuItem key={subIndex} onClick={subItem.onClick}>
                            <ListItemIcon>{subItem.icon}</ListItemIcon>
                            <ListItemText
                              className={clsx(classes.text, "reyu")}
                            >
                              {subItem.title}
                            </ListItemText>
                          </MenuItem>
                        ) : (
                          <li
                            key={subIndex}
                            className={
                              !!subItem?.internal && !canSeeInternal
                                ? "cant-see"
                                : ""
                            }
                          >
                            <Link to={subItem?.path || ""}>
                              <MenuItem
                                className={`${subItem?.className || ""} reejus-test ${pathName.includes(subItem?.pathName) ? "active" : ""} `}
                                onClick={() => {
                                  subItem.loc === "live-chat" &&
                                    nameChanger(true);
                                }}
                              >
                                <ListItemIcon>{subItem?.icon}</ListItemIcon>
                                <ListItemText
                                  className={clsx(classes.text, "reyu")}
                                >
                                  {subItem.title}
                                </ListItemText>
                              </MenuItem>
                            </Link>
                          </li>
                        );
                      })}
                    </NestedMenuItem>
                  </React.Fragment>
                ) : (
                  <React.Fragment key={index}>
                    {index === SidebarData.length - 3 && (
                      <div
                        style={{
                          height: `calc(100vh - 290px - ${index * 35}px)`,
                        }}
                      ></div>
                    )}
                    {item.divider ? (
                      <div className="sidebar-divider"></div>
                    ) : item.toggleMenuItem ? (
                      isMobile || sidebarOpen ? (
                        <div className={`toggle-menu-item`} key={index}>
                          {item.icon}
                          <span
                            className={classes.text}
                            style={{ width: "110px" }}
                          >
                            {item.title}
                          </span>
                          <MaterialUISwitch
                            checked={themeMode === "dark"}
                            onClick={() => {
                              themeToggle(
                                themeMode === "light" ? "dark" : "light",
                              );
                            }}
                          />
                        </div>
                      ) : (
                        <li style={{ marginBottom: "5px" }}>
                          <div
                            className="theme-toggle-switch"
                            onClick={() => {
                              themeToggle(
                                themeMode === "light" ? "dark" : "light",
                              );
                            }}
                          >
                            {item.icon}
                          </div>
                        </li>
                      )
                    ) : (
                      <li
                        className={`${item?.className || ""} ${!!item?.internal && !canSeeInternal ? "cant-see" : ""} ${pathName.includes(item.pathName) ? "active" : ""}`}
                        key={index}
                      >
                        <Link to={item?.path || ""}>
                          {item.icon}
                          <span className={classes.text}>{item.title}</span>
                          {item.badge && (
                            <div className="upgrade-button">
                              <ArrowCircleUpIcon />
                              upgrade
                            </div>
                          )}
                          {item.external && (
                            <div className="new-badge">NEW</div>
                          )}
                        </Link>
                      </li>
                    )}
                  </React.Fragment>
                );
              })}
          </ul>
          <div className="card sidebar-alert border-0 text-center mx-4 mb-0 mt-5"></div>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

const stateToProps = (state) => ({
  sidebarOpen: state.sidebarOpen.open,
  themeMode: state.themeMode.themeMode,
  layoutMode: state.layoutMode.layoutMode,
  userSettings: state.userSettings.userSettings,
  liveChatExpanded: state.hideLiveChat.liveChatExpanded,
  defaultTickersSettings:
    state.userSettings.userSettings.defaultLiveOptionsTickers,
});

const dispatchToProps = (dispatch) => ({
  setSidebar: (open) => dispatch(sidebarSetter(open)),
  themeToggle: (themeMode) => dispatch(themeSetter(themeMode)),
  nameChanger: (change) => dispatch(nameChange(change)),
  setUserSettings: (settings, firstRender) =>
    dispatch(addUserSettingsLoad(settings, firstRender)),
  setHideChat: (open, liveChatExpanded) =>
    dispatch(liveChatSetter(open, liveChatExpanded)),
  setShowJourney: (run) => dispatch(runJourneySetter(run)),
});

export default connect(stateToProps, dispatchToProps)(SidebarContent);
